<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.125 2.75C8.14062 2.75 7.375 3.54297 7.375 4.5V10.625C7.375 11.6094 8.14062 12.375 9.125 12.375H15.25C16.207 12.375 17 11.6094 17 10.625V4.5C17 3.54297 16.207 2.75 15.25 2.75H9.125ZM4.75 7.125C3.76562 7.125 3 7.91797 3 8.875V15C3 15.9844 3.76562 16.75 4.75 16.75H10.875C11.832 16.75 12.625 15.9844 12.625 15V13.25H10.875V15H4.75V8.875H6.5V7.125H4.75Z"
      fill="currentColor"
    />
  </svg>
</template>
